export default "__VITE_ASSET__BxzjWGZ2__";